@if (view$ | async; as view) {
    @if (view.user.loading) {
        <app-load />
    } @else if (!view.user.loading && view.user.value; as user) {
        <div class="container-fluid my-3">
            <!-- Header -->
            <div class="mb-4">
                <h3 class="mb-0">{{ user.personName ?? user.userName }}</h3>
            </div>

            <div class="mx-auto slim-card-container">
                <!-- User info form -->
                <form [formGroup]="formGroup">
                    <div>
                        <div class="card mb-3">
                            <div class="card-body">
                                <div class="mb-3">
                                    <h5 class="mb-0">
                                        {{
                                            'titles_userInfo'
                                                | translate: 'online' : 'userAdministration'
                                        }}
                                    </h5>
                                </div>
                                <app-input-text-group
                                    formControlName="personName"
                                    [label]="
                                        'properties_name'
                                            | translate: 'online' : 'userAdministration'
                                    " />
                                <app-input-text-group
                                    formControlName="userName"
                                    [label]="
                                        'properties_username'
                                            | translate: 'online' : 'userAdministration'
                                    " />
                                <app-input-text-group
                                    formControlName="email"
                                    [label]="
                                        'properties_email'
                                            | translate: 'online' : 'userAdministration'
                                    " />
                                <app-input-select-option-group
                                    formControlName="role"
                                    [label]="
                                        'properties_role'
                                            | translate: 'online' : 'userAdministration'
                                    "
                                    [data]="roleOptions" />
                                <app-input-text-area-group
                                    formControlName="note"
                                    [label]="
                                        'properties_note'
                                            | translate: 'online' : 'userAdministration'
                                    "
                                    [maxLength]="100" />
                            </div>
                        </div>
                    </div>
                </form>

                <!-- System access -->
                @if (view.showSystemAccess) {
                    <app-system-access-picker
                        [assignedBuildingNos]="assignedBuildingNos()"
                        (assignedBuildingNosChange)="assignedBuildingNos.set($event)"
                        (changed)="formGroup.markAsDirty()" />
                }

                <!-- Actions -->
                <div class="d-flex justify-content-between align-items-center mt-3">
                    <button
                        class="btn btn-outline-danger"
                        (click)="deleteUser(user.loginNameId, user.personName ?? user.userName)">
                        <i class="bi bi-trash"></i>
                        {{ 'actions_deleteUser' | translate: 'online' : 'userAdministration' }}
                    </button>
                    <div class="d-flex gap-2">
                        @if (canResetPassword()) {
                            <button
                                class="btn btn-outline-primary"
                                (click)="forgotPassword(user.loginNameId)">
                                {{
                                    'actions_forgotPassword'
                                        | translate: 'online' : 'userAdministration'
                                }}
                            </button>
                        }
                        <button
                            class="btn btn-primary"
                            [disabled]="isSaving()"
                            (click)="saveChanges(user.loginNameId)">
                            {{ 'actions_saveChanges' | translate: 'online' : 'common' }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    }
}
